import {
  textGray400,
  textNegativeText,
} from '@osmosis/tailwind-ui/styles/text';
import { ModalHookProps } from '../../../hooks/useModal';

export const path = {
  scheduleForReview: '/scheduleForReview',
  /**
   * Return url with nodeId.
   */
  editques: (nodeId: number) => `/editques?n=${nodeId}`,
  mobileRescheduleQues: '/mobileRescheduleQues',
} as const;

export const ids = {
  dots: 'quiz.quiz-settings-popup.dots',
  header: 'quiz.quiz-settings-popup.options-header',
  repeatItems: 'quiz.quiz-settings-popup.repeat-items',
  repeat1: 'quiz.quiz-settings-popup.repeat-1',
  repeat1Snack: 'quiz.quiz-settings-popup.repeat-1.snackbar',
  noRepeat: 'quiz.quiz-settings-popup.no-repeat',
  noRepeatSnack: 'quiz.quiz-settings-popup.no-repeat.snackbar',
  priorityFlag: 'quiz.quiz-settings-popup.priority-flag',
  report: 'quiz.quiz-settings-popup.report',
  admin: 'quiz.quiz-settings-popup.admin',
  error: 'quiz.quiz-settings-popup.error',
  border: 'quiz.quiz-settings-popup.border',
} as const;

/**
 * MockedQuizItems.
 */
export const mockedQuizItems = (feedbackModal: ModalHookProps) => [
  {
    id: 'quiz.quiz-settings-popup.repeat-items',
    items: [
      {
        id: 'quiz.quiz-settings-popup.repeat-1',
        text: 'Repeat in 1 day',
        value: 1,
        snackBarMessage: 'Flashcard will repeat in 1 day',
      },
      {
        id: 'quiz.quiz-settings-popup.no-repeat',
        text: "Don't repeat",
        textColor: textNegativeText,
        snackBarMessage: 'Repetition switched off for this flashcard',
        value: -1,
      },
    ],
  },
  {
    id: 'quiz.quiz-settings-popup.priority-flag',
    text: 'Flag as priority for spaced repetition',
    icon: {
      prefix: 'fas',
      iconName: 'flag',
      icon: [
        448,
        512,
        [127988, 61725],
        'f024',
        'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z',
      ],
    },
    iconColor: textGray400,
  },
  {
    id: 'quiz.quiz-settings-popup.report',
    text: 'Report an issue',
    icon: {
      prefix: 'fas',
      iconName: 'comment-exclamation',
      icon: [
        512,
        512,
        [],
        'f4af',
        'M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm0-336c13.3 0 24 10.7 24 24V248c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24zm32 224c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z',
      ],
    },
    iconColor: textGray400,
    onClick: () => {
      feedbackModal.show();
    },
  },
];
